import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Input, Label } from './styles';

export const TextInput = ({
	disabled,
	name,
	label,
	value,
	onChange,
	placeholder,
	type,
}) => {
	return (
		<Wrapper>
			{label && <Label>{label}</Label>}
			<Input
				type={type || 'text'}
				disabled={disabled}
				name={name}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
			/>
		</Wrapper>
	);
};

TextInput.propTypes = {
	name: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	onChange: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
};

TextInput.defaultProps = {
	disabled: false,
};
